.hero {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8rem 6vw 6rem;
}

.inner {
  max-width: 860px;
}

.eyebrow {
  font-family: var(--font-display);
  font-size: clamp(2.8rem, 7vw, 5rem);
  font-weight: 900;
  color: var(--white);
  letter-spacing: -0.03em;
  margin-bottom: 0.75rem;
  line-height: 1;
  animation: fadeUp 0.65s ease both;
}

.brandName {
  font-family: var(--font-display);
  font-size: clamp(3rem, 7vw, 5rem);
  font-weight: 900;
  color: var(--white);
  letter-spacing: -0.025em;
  line-height: 0.96;
  margin-bottom: 0.5rem;
  animation: fadeUp 0.65s ease both;
}

.heading {
  font-family: var(--font-display);
  font-size: clamp(3rem, 7.5vw, 7rem);
  font-weight: 900;
  line-height: 0.96;
  color: var(--white);
  letter-spacing: -0.025em;
  margin-bottom: 1.8rem;
  animation: fadeUp 0.65s 0.1s ease both;
}

.accent {
  color: var(--teal);
  position: relative;
  display: inline-block;
}

.underline {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--teal) 0%, transparent 100%);
  border-radius: 2px;
}

.sub {
  font-size: 1.1rem;
  color: var(--mist);
  line-height: 1.8;
  max-width: 520px;
  margin-bottom: 2.5rem;
  animation: fadeUp 0.65s 0.2s ease both;
}

.actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 3rem;
  animation: fadeUp 0.65s 0.3s ease both;
}

.btnPrimary {
  display: inline-block;
  background: var(--teal);
  color: var(--ink);
  text-decoration: none;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.875rem;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  padding: 0.9rem 2rem;
  border-radius: 5px;
  transition: background 0.2s, transform 0.15s;
}

.btnPrimary:hover {
  background: #7ee8d8;
  transform: translateY(-2px);
}

.btnSecondary {
  display: inline-block;
  border: 1px solid var(--teal-border);
  color: var(--mist);
  text-decoration: none;
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  padding: 0.9rem 2rem;
  border-radius: 5px;
  transition: border-color 0.2s, color 0.2s, transform 0.15s;
}

.btnSecondary:hover {
  border-color: var(--teal);
  color: var(--teal);
  transform: translateY(-2px);
}

.pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  animation: fadeUp 0.65s 0.4s ease both;
}

.pill {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  letter-spacing: 0.1em;
  color: rgba(99, 210, 190, 0.65);
  border: 1px solid rgba(99, 210, 190, 0.15);
  padding: 0.3rem 0.7rem;
  border-radius: 20px;
  background: rgba(99, 210, 190, 0.04);
}

.scrollIndicator {
  position: absolute;
  bottom: 2.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  opacity: 0.4;
  animation: fadeIn 1.2s 1s ease both;
}

.scrollLabel {
  font-family: var(--font-mono);
  font-size: 0.62rem;
  letter-spacing: 0.18em;
  color: var(--mist);
  text-transform: uppercase;
}

.scrollLine {
  width: 1px;
  height: 44px;
  background: linear-gradient(to bottom, var(--teal), transparent);
  animation: pulse-line 2s ease-in-out infinite;
}

@media (max-width: 600px) {
  .hero { padding: 7rem 5vw 4rem; }
  .actions { flex-direction: column; }
  .btnPrimary, .btnSecondary { text-align: center; }
  .scrollIndicator { display: none; }
}
